<template>
    <a-drawer placement="right" :closable="true" :visible="visible" :width="drawerWidth" :destroyOnClose="true"
        :forceRender="true" :bodyStyle="bodyStyle" :wrapStyle="wrapStyle" wrapClassName="drawer" @close="onClose">

        <template #title>
            <a-page-header style="padding: 0;" title="原料评估" />
        </template>

        <a-table class="a-table" :columns="tableColumns_1" :data-source="tableData_1" :loading="tableLoading"
            size="small" :pagination="false"></a-table>

        <a-table class="a-table" :columns="tableColumns_2" :loading="tableLoading" :data-source="tableData_2"
            size="small" :pagination="false"></a-table>

        <!-- 新增 footer 插槽 -->
        <div class="footer">
            <a-button type="primary" :disabled="exportDisabled" @click="onExportBtnClick">导出报表</a-button>
        </div>
    </a-drawer>
</template>

<script>
import { exportExcel } from "@/Utils/excel/Export2Excel";

const tableColumns_1 = [
    {
        title: "评估原料",
        align: 'center',
        dataIndex: "rawName",
        minWidth: 120,
    },
    {
        title: "总使用量(吨/月)",
        align: 'center',
        dataIndex: "totalUasge",
        width: 120,
    },
    {
        title: "总节省(元/月)",
        align: 'center',
        dataIndex: "totalSavePrice",
        width: 120,
    },
    {
        title: "原料单吨节省(元)",
        align: 'center',
        dataIndex: "rawSingleSavePrice",
        width: 120,
    },
    {
        title: "产品单吨节省(元)",
        align: 'center',
        dataIndex: "proSingleSavePrice",
        width: 120,
    },
    {
        title: "用量拐点",
        align: 'center',
        dataIndex: "uasgePoint",
        width: 120,
    },
    {
        title: "使用比例(%)",
        align: 'center',
        dataIndex: "uasgePer",
        width: 120,
    },
    {
        title: "影子价格上限",
        align: 'center',
        dataIndex: "maxShadowPrice",
        width: 120,
    },
];

const tableColumns_2 = [
    {
        title: "原料",
        align: 'center',
        dataIndex: "rawName",
        width: 100,
    },
    {
        title: "价格",
        align: 'center',
        dataIndex: "rawPrice",
        width: 60,
    },
    {
        title: "用量(吨)",
        align: 'center',
        dataIndex: "rawUasge",
        width: 60,
    },
    {
        title: "之前用量(吨)",
        align: 'center',
        dataIndex: "lastUasge",
        width: 60,
    },
    {
        title: "差异(吨)",
        align: 'center',
        dataIndex: "diffUasge",
        width: 60,
    },
];

export default {
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        taskId: {
            type: String,
            default: ''
        },
        selectedRows: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            tableLoading: false,

            tableColumns_1,
            tableData_1: [],

            tableColumns_2,
            tableData_2: [],
            scrollX: 1140,
            drawerWidth: 1000,
            wrapStyle: {
                overflow: 'hidden'
            },
            bodyStyle: {
                overflow: 'hidden',
            },

        };
    },
    watch: {
        visible(val) {
            if (val) {
                this.rawId = this.selectedRows[0].rawId;
                this.getData();
            }
        },
    },
    computed: {
        exportDisabled() {
            return !this.tableData_1.length && !this.tableData_2.length;
        }
    },
    mounted() {
        const viewportWidth = window.innerWidth;
        const _width = viewportWidth * 0.8;
        if (_width < 1000) {
            this.drawerWidth = _width;
            this.scrollX = _width - 80;
        }
    },
    methods: {
        getData() {
            this.tableLoading = true;
            this.$get('/nhf-app/formulaspeedtaskraw/getEstimateRawData', { rawId: this.rawId, taskId: this.taskId }).then(res => {
                this.tableData_1 = [res.data.rawEstVO];
                this.tableData_2 = res.data.rawEstVOTableList;
            }).finally(() => {
                this.tableLoading = false;
            });
        },
        onClose() {
            this.$emit('close');
        },
        // 修改导出 Excel 方法
        onExportBtnClick() {
            // 获取第一个表格的表头和数据
            const tHeader_1 = this.tableColumns_1.map((item) => item.title);
            const filterVal_1 = this.tableColumns_1.map((item) => item.dataIndex);
            const data_1 = this.tableData_1.map((v) => filterVal_1.map((j) => v[j] || ''));

            // 获取第二个表格的表头和数据
            const tHeader_2 = this.tableColumns_2.map((item) => item.title);
            const filterVal_2 = this.tableColumns_2.map((item) => item.dataIndex);
            const data_2 = this.tableData_2.map((v) => filterVal_2.map((j) => v[j] || ''));

            // 将第二个表格的表头作为数据行插入
            const headerAsDataRow = tHeader_2.map((title) => title);

            // 合并数据，两个表的数据之间用一个空行隔开
            const mergedData = [
                ...data_1, // 第一个表格的数据
                Array(tHeader_1.length).fill(''), // 空行，长度与第一个表头一致
                headerAsDataRow, // 第二个表格的表头作为数据行
                ...data_2, // 第二个表格的数据
            ];

            // 导出 Excel
            const tTitle = `原料评估数据`;
            exportExcel(tHeader_1, mergedData, tTitle); // 使用第一个表头作为 Excel 表头
        },
    }
};
</script>

<style lang="scss" scoped>
::v-deep .a-table {
    .ant-table {
        border-radius: 0;
    }
}

::v-deep .drawer {
    overflow: hidden;
    position: relative;

    .ant-drawer-wrapper-body {
        overflow: hidden;
        height: 100%;
    }
}

.footer {
    position: absolute;
    bottom: 20px;
    left: 0;
    right: 20px;
    text-align: right;
}
</style>
